import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CartItemsInt } from '@app/interfaces/micro/cart.interface';
import { CartService } from '@app/services/cart.service';
@Component({
    selector: 'app-am-cart-item',
    templateUrl: './am-cart-item.component.html',
    styleUrls: ['./am-cart-item.component.scss'],
    standalone: false
})
export class AmCartItemComponent implements OnInit {

  @Input() cartItems: CartItemsInt[] = [];
  @Input() namePassenger: string = '';
  @Input() showDetail: boolean = false;
  @Input() screen: string = 'cart';
  @Output() dataChanged = new EventEmitter<CartItemsInt>();
  constructor(private _cartService: CartService,) { }

  ngOnInit(): void {
    console.log('{{cartItems}}', this.cartItems);
    
  }

  handleDeleteItem(item:any) {
    this.dataChanged.emit(item); 
  }

}
